import React, { useEffect, useState } from 'react';
import useTranslate from '../../../../common/hooks/useTranslate';
import CardWrapper from '../../../ui/card/cardWrapper/cardWrapper';
import { saveUserSettings } from '../../../../common/services/http/userService';

import './userSettings.scss';

interface ISettingsCard {
  settings?: ISetting[];
}

interface ISetting {
  name: string;
  value: any;
}

const getTooltipLabel = (tooltipSettingHidden: string): string => {
  return tooltipSettingHidden === '1' ? 'Hidden' : 'Shown';
};

const UserSettings: React.FC<ISettingsCard> = ({ settings }) => {
  const { t } = useTranslate();

  const slicerTooltipSetting = settings.find((setting) => {
    return setting.name === 'docuSlicerTooltipHidden';
  });
  const tooltipSettingValue = slicerTooltipSetting && slicerTooltipSetting.value;

  const [tooltipValue, setTooltipValue] = useState(getTooltipLabel(tooltipSettingValue));

  const resetTooltipSettings = () => {
    const slicerTooltipSetting = { name: 'docuSlicerTooltipHidden', value: '0' };
    saveUserSettings(slicerTooltipSetting);
    setTooltipValue('Shown');
  };

  useEffect(() => {
    setTooltipValue(getTooltipLabel(tooltipSettingValue));
  }, [settings]);

  return (
    <CardWrapper className="width660">
      <div className="title-flex-wrapper">
        <span className="card-title">{t('PROFILE.SETTINGS_TITLE')}</span>
      </div>
      {settings && (
        <div className="settings-row">
          <div className="settings-label">{t('PROFILE.TOOLTIP_SETTING')}</div>
          <div className="settings-value">{tooltipValue}</div>
          <div>
            <button onClick={resetTooltipSettings} className="reset-settings-button" disabled={tooltipValue === 'Shown'}>
              {t('PROFILE.RESET_SETTING')}
            </button>
          </div>
        </div>
      )}
    </CardWrapper>
  );
};

export default UserSettings;
